/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

export default {
  colors: ['#FF495E', '#28277E', '#6D5BD1', '#F9DCE7', '#AEC8FA', '#DDD8F5'],
  chart: {
    style: {
      fontFamily: 'gordita'
    }
  },
  title: {
    text: 'Lorem ipsum dolor sit amet',
    align: 'left'
  },
  subtitle: {
    text: 'consectetur adipiscing elit, sed do eiusmod',
    align: 'left'
  },
  credits: {
    text: 'www.everviz.com',
    href: 'https://www.everviz.com'
  },
  plotOptions: {
    series: {
      borderRadius: 2,
      pointPadding: 0.01,
      groupPadding: 0.05,
      borderWidth: 0,
      shadow: false,
      marker: {
        enabled: false
      },
      lineWidth: 3
    }
  },
  legend: {
    align: 'left',
    verticalAlign: 'top',
    itemMarginBottom: 10,
    x: 0,
    symbolRadius: 2
  }
};
